
import './App.scss';

import Home  from "./pages/home/Home";
import China  from "./pages/china/China";
import Azerbaijan  from "./pages/azerbaijan/Azerbaijan";
import ChinaService from './pages/china-service/ChinaService';
import ChinaCities from './pages/china-cities/ChinaCities';
import ChinaTours from './pages/china-tours/ChinaTours';
import ChinaTourDetails from './pages/china-tour-details/ChinaTourDetails';
import ChinaHotels from './pages/china-hotels/ChinaHotels';
import ChinaHotelDetails from './pages/china-hotel-details/ChinaHotelDetails';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
    <Routes>
    <Route path='/' element={<Home />} />
    <Route path='china' element={<China />} />
    <Route path='azerbaijan' element={<Azerbaijan />} />
    <Route path='service' element={<ChinaService/>} />
    <Route path='cities' element={<ChinaCities/>} />
    <Route path='tours' element={<ChinaTours/>} />
    <Route path='details' element={<ChinaTourDetails/>} />
    <Route path='hotels' element={<ChinaHotels/>} />
    <Route path='hotelDetails' element={<ChinaHotelDetails/>} />

    </Routes>
    </BrowserRouter>
  );
}

export default App;
